

































































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import GarantiaMinimaStore from '@/components/RemuneracaoMedica/financeiro/Store/GarantiaMinimaStore'
import EventBus from '@/plugins/EventBus'
import { maskMoney } from '@/utils/common'

@Component
export default class ViewFinanceiroTaxaAluguel extends Vue {
  menu: boolean = false
  searchPrestador: string = ''
  loadingPrestadorFilter: boolean = false
  ignoreNextPrestadorSearch: boolean = false

  prestadoresDebounced = _.debounce(async (search: string) => {
    await this.garantiaMinimaGlobalStore.getListaPrestadores(search)
    this.loadingPrestadorFilter = false
  }, 700)

  $refs!: {
    formGarantia: any
  }

  form: any = {
    valid: true,
    anoMes: [(v: any) => !!v || 'Campo obrigatório'],
    prestador: [(v: any) => !!v || 'Campo obrigatório'],
  }

  get garantiaMinimaGlobalStore() {
    return getModule(GarantiaMinimaStore, this.$store)
  }

  get successList() {
    return this.garantiaMinimaGlobalStore.successList
  }

  loadGetCalcularTaxaAluguel: boolean = false
  get loadingGetCalcularTaxaAluguel() { return this.loadGetCalcularTaxaAluguel }
  set loadingGetCalcularTaxaAluguel(value) { this.loadGetCalcularTaxaAluguel = value }

  loadCalcularTaxaAluguel: boolean = false
  get loadingCalcularTaxaAluguel() { return this.loadCalcularTaxaAluguel }
  set loadingCalcularTaxaAluguel(value) { this.loadCalcularTaxaAluguel = value }

  get prestadores() { return this.garantiaMinimaGlobalStore.listaPrestadores }
  get errorList() { return this.garantiaMinimaGlobalStore.errorList }

  get selectedPrestador() { return this.garantiaMinimaGlobalStore.selectedPrestador }
  set selectedPrestador(value) { this.garantiaMinimaGlobalStore.setSelectedPrestador(value) }

  get selectedMesReferencia() { return this.garantiaMinimaGlobalStore.selectedMesReferencia }
  set selectedMesReferencia(value) { this.garantiaMinimaGlobalStore.setSelectedMesReferencia(value) }

  get getMenu() { return this.menu }
  set getMenu(value: boolean) { this.menu = value }

  get showCard() { return this.garantiaMinimaGlobalStore.errorList.length > 0 || this.garantiaMinimaGlobalStore.showSuccessScreen }

  maskMoney(value: any) {
    return maskMoney(value)
  }

  async getCalcularGarantiaMinima() {
    this.loadingGetCalcularTaxaAluguel = true
    if (!this.$refs.formGarantia.validate()) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Preencha todos os campos!', icon: 'warning', color: '#C62828' })
      return
    }
    const response = await this.garantiaMinimaGlobalStore.getCalcularGarantiaMinima()

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Erro na requisição', icon: 'warning', color: '#C62828' })
      this.loadingGetCalcularTaxaAluguel = false
      return
    }

    EventBus.$emit('setSnackbar', { show: true, text: 'Calculo realizado com sucesso!', icon: 'done', color: '#2E7D32' })
    this.loadingGetCalcularTaxaAluguel = false
  }

  async calcularGarantiaMinima() {
    this.loadingCalcularTaxaAluguel = true
    const response = await this.garantiaMinimaGlobalStore.calcularGarantiaMinima()

    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Erro ao calcular a garantia mínima!', icon: 'warning', color: '#C62828' })
      this.loadingCalcularTaxaAluguel = false
      return
    }

    this.garantiaMinimaGlobalStore.setShowSuccessScreen(false)
    this.selectedMesReferencia = ''
    this.selectedPrestador = ''
    this.$refs.formGarantia.resetValidation()
    EventBus.$emit('setSnackbar', { show: true, text: 'Item de garantia gerado com sucesso!', icon: 'done', color: '#2E7D32' })
    this.loadingCalcularTaxaAluguel = false
  }

  @Watch('searchPrestador')
  async onSearchPrestadorChanged(val: string) {
    if (this.ignoreNextPrestadorSearch) {
      this.ignoreNextPrestadorSearch = false
      return
    }

    if (!val || val.length < 3) {
      return
    }

    this.loadingPrestadorFilter = true
    if (this.prestadoresDebounced) await this.prestadoresDebounced(val)
  }

  onChangePrestador() {
    this.loadingPrestadorFilter = false
    this.ignoreNextPrestadorSearch = true
  }

  async clearPrestador() {
    this.prestadoresDebounced.cancel()
    this.searchPrestador = ''
    this.selectedPrestador = ''
    this.loadingPrestadorFilter = true
    await this.garantiaMinimaGlobalStore.getListaPrestadores()
    this.loadingPrestadorFilter = false
  }

  async mounted() {
    this.selectedMesReferencia = ''
    this.selectedPrestador = ''
    this.searchPrestador = ''
  }
}
